"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStaking = exports.StakingModule = void 0;
var base_1 = __importDefault(require("./base"));
var bootstrap_1 = require("../bootstrap");
var StakingModule = (function (_super) {
    __extends(StakingModule, _super);
    function StakingModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StakingModule.prototype.getAllDelegationsByDelegator = function (delegatorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/staking/delegators/" + delegatorAddr + "/delegations")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.queryCurrentDelegationBetweenDelegatorValidator = function (delegatorAddr, validatorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/staking/delegators/" + delegatorAddr + "/delegations/" + validatorAddr)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.getAllUnbondingDelegationsByDelegator = function (delegatorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/staking/delegators/" + delegatorAddr + "/unbonding_delegations")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.queryAllUbondingDelegationsBetweenDelegatorAndValidator = function (delegatorAddr, validatorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client("/staking/delegators/" + delegatorAddr + "/unbonding_delegations/" + validatorAddr)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.queryAllValidatorsThatDelegatorIsBondedTo = function (delegatorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.get("/staking/delegators/" + delegatorAddr + "/validators")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.queryValidatorThatDelegatorIsBondedTo = function (delegatorAddr, validatorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client("/staking/delegators/" + delegatorAddr + "/validators/" + validatorAddr)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.stakingValidators = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client("/staking/validators")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.queryValidatorInfo = function (validatorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client("/staking/validators/" + validatorAddr)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.gettAllDelegationsByValidator = function (validatorAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client("/staking/validators/" + validatorAddr + "/delegations")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.getCurrentStateOfStakingPool = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client("/staking/pool")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.getCurrentStakingParameterValues = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client("/staking/parameters")];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.submitDelegation = function (delegatorAddr, body_request) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.post("/staking/delegators/" + delegatorAddr + "/delegations", body_request)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.submitUnbondingDelegation = function (delegatorAddr, body_request) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.post("/staking/delegators/" + delegatorAddr + "/unbonding_delegations", body_request)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    StakingModule.prototype.submitRedelegation = function (delegatorAddr, body_request) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.client.post("/staking/delegators/" + delegatorAddr + "/redelegations", body_request)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data];
                }
            });
        });
    };
    return StakingModule;
}(base_1.default));
exports.StakingModule = StakingModule;
var stakingModule;
function useStaking() {
    var config = bootstrap_1.getConfig();
    if (!config)
        throw new Error('Not Client available');
    if (!stakingModule) {
        stakingModule = new StakingModule(config.restUrl);
    }
    return stakingModule;
}
exports.useStaking = useStaking;
//# sourceMappingURL=staking.js.map